import { formatUsdPerGaju, price as toPrice } from '@xchange/core';
import { decimalSeparator } from './numbers.js';

/** Price and fee arithmetic the trade screens share. Pure, so it can be tested. */
export interface PriceTerms {
  readonly quote: string;
  readonly feeBps: number;
}

/** A price in the pair's unit as a plain decimal with every digit, for an input. */
export function priceInput(pair: PriceTerms, units: bigint): string {
  const decimals = pair.quote === 'GAJU' ? 18 : 6;
  const scale = 10n ** BigInt(decimals);
  const frac = (units % scale).toString().padStart(decimals, '0').replace(/0+$/, '');
  return `${(units / scale).toString()}${frac === '' ? '' : `.${frac}`}`;
}

/** What a person receives of a leg: the contract keeps its fee. */
export function netOfFee(pair: PriceTerms, amount: bigint): bigint {
  return amount - (amount * BigInt(pair.feeBps)) / 10_000n;
}

/**
 * A price as the price box shows it: per single Gaju when `perOne` on a Gaju
 * pair, otherwise in the pair's own unit; every digit, in this phone's decimal
 * separator, so the box reads it back as the same price. A dot on a comma
 * phone would turn "1.234" into 1,234.
 */
export function priceBoxText(
  pair: PriceTerms & { readonly base: string },
  units: bigint,
  perOne: boolean,
  separator: '.' | ',' = decimalSeparator(),
): string {
  const text =
    pair.base === 'GAJU' && perOne
      ? formatUsdPerGaju(toPrice(units)).replace('$', '').replace(/,/g, '')
      : priceInput(pair, units);
  return text.replace('.', separator);
}
